import React from "react";
import Card from "react-bootstrap/Card";
import { IoIosArrowDroprightCircle } from "react-icons/io";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify", fontSize: "23px" }}>
            Hi Everyone, I am <span className="purple">Jimson Montederamos, </span>
            based in <span className="purple"> Auckland, New Zealand.</span>
            <br /> I obtained my coding skills from Mission Ready HQ, a coding bootcamp based in Auckland, New Zealand.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <IoIosArrowDroprightCircle /> Playing Games
            </li>
            <li className="about-activity">
              <IoIosArrowDroprightCircle /> Watching Youtube Tutorials
            </li>
            <li className="about-activity">
              <IoIosArrowDroprightCircle /> Travelling
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
